module.exports = __webpack_public_path__ + "static/media/cards_ui.39320e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumb/cards_ui.png
// module id = 56
// module chunks = 0